module.exports = __webpack_public_path__ + "static/media/slider-l2-768.70445da4.webp";